import React from "react";
import styled from "styled-components";
import { InputNumber, Slider } from "antd";
import { SliderMarks } from "antd/es/slider";
import { useTranslation } from "react-i18next";

import variableColors from "../../_App.module.scss";

const { secondaryColor } = variableColors;

const SliderDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: space-between;
  gap: 0.5rem;
  margin: 0;
`;

const SliderInputDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  gap: 1rem;
`;

const DeviationReportSliders = ({
  inputNegativeValue,
  setInputNegativeValue,
  inputValuePositive,
  setInputValuePositive,
  setShouldReloadWindow,
}: {
  inputNegativeValue: number;
  setInputNegativeValue: (arg0: number) => void;
  inputValuePositive: number;
  setInputValuePositive: (arg0: number) => void;
  setShouldReloadWindow?: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element => {
  const { t } = useTranslation();

  const formatter = (value: number | undefined) => `${value} min`;

  const onChangeNegative = (negativeValue: number) => {
    if (isNaN(negativeValue)) {
      return;
    }
    setInputNegativeValue(negativeValue);

    if (setShouldReloadWindow) {
      setShouldReloadWindow(true);
    }
  };

  const onChangePositive = (positiveValue: number) => {
    if (isNaN(positiveValue)) {
      return;
    }
    setInputValuePositive(positiveValue);

    if (setShouldReloadWindow) {
      setShouldReloadWindow(true);
    }
  };

  const marksNegative: SliderMarks = {
    "-10": "-10min",
    "-5": {
      style: {
        color: secondaryColor,
      },
      label: `${t("Allowable Late")}`,
    },
    0: "0min",
  };

  const marksPositive: SliderMarks = {
    0: "0min",
    5: {
      style: {
        color: secondaryColor,
      },
      label: `${t("Allowable Early")}`,
    },
    10: "10min",
  };

  return (
    <React.Fragment>
      <SliderDiv>
        <SliderInputDiv>
          <Slider
            marks={marksNegative}
            min={-10}
            max={0}
            onChange={onChangeNegative}
            value={typeof inputNegativeValue === "number" ? inputNegativeValue : 0} //* [min]
            step={0.1}
            style={{ width: "calc(100% - 5rem)", minWidth: "5rem" }}
            tooltip={{ formatter, open: undefined, placement: "top" }}
          />
          <InputNumber
            min={-10}
            max={0}
            style={{ width: "4.5rem" }}
            step={0.1}
            value={inputNegativeValue} //* [min]
            onChange={(value) => onChangeNegative(value as number)}
          />
        </SliderInputDiv>
        <SliderInputDiv>
          <Slider
            marks={marksPositive}
            min={0}
            max={10}
            onChange={onChangePositive}
            value={typeof inputValuePositive === "number" ? inputValuePositive : 0} //* [min]
            step={0.1}
            style={{ width: "calc(100% - 5rem)", minWidth: "5rem" }}
            tooltip={{ formatter, open: undefined, placement: "bottom" }}
          />
          <InputNumber
            min={0}
            max={10}
            style={{ width: "4.5rem" }}
            step={0.1}
            value={inputValuePositive} //* [min]
            onChange={(value) => onChangePositive(value as number)}
          />
        </SliderInputDiv>
      </SliderDiv>
    </React.Fragment>
  );
};

export default DeviationReportSliders;
